document.body.addEventListener('click', function (event) {
  if (!event.target.classList.contains('templates__title')) return; // event.stopPropagation();

  var item = event.target.closest('.templates');
  if (item) item.classList.toggle('opened');
  event.preventDefault();
}, true);
document.querySelectorAll('.field__list-wrap input[type="text"]').forEach(function (input) {
  input.addEventListener('focus', function (event) {
    console.log(input.target);
    console.log(input.parentNode);
    console.log(input.parentNode.previousElementSibling);
    event.target.parentNode.previousElementSibling.checked = true;
  });
});